<template>
	<Col>
		<AppVMenu
			right
			rounded="lg"
			nudge-top="9"
			nudge-right="296"
			v-model="showMenu"
			:close-on-content-click="false"
			transition="slide-x-transition"
		>
			<template v-slot:activator="{ on, attrs }">
				<div @click="onActivatorClick" v-on="on" v-bind="attrs" class="display-flex flex-row flex-align-center width-100 pr-2">
					<Row :class="{ open: showMenu }" class="activator flex-align-center width-100 px-1 flex-justify-space-between pl-5">
						<h3 class="reg activator-title">{{ title }}</h3>
						<v-icon class="chevron">mdi-chevron-right</v-icon>
					</Row>
				</div>
			</template>
			<component :is="menuContent.component" v-bind="menuContent.props" class="menu-content-container" />
		</AppVMenu>
	</Col>
</template>

<script>
export default {
	name: 'GroupFeatureVisibilityForMembersGroupActivator',
	props: { title: { type: String }, menuContent: { type: Object } },
	methods: {
		openMenu() {
			this.showMenu = true;
		},
		onActivatorClick(e) {
			this.openMenu();
			e.stopPropagation();
		},
	},
	data() {
		return { showMenu: false };
	},
};
</script>

<style scoped lang="scss">
$menu-width: 380px;
.activator {
	min-height: 40px;
	background: var(--bg-color);
	transition: var(--transition-time);
	&.open,
	&:hover {
		background: #f6f8fb;
		transition: var(--transition-time);
	}
}
.chevron {
	font-size: 12px;
	color: var(--primary-font-color);
}
.menu-content-container {
	height: 212px;
	height: 172px;
	width: $menu-width;
	min-width: $menu-width;
	max-width: $menu-width;
}
.activator-title {
	color: var(--bold-title);
}
</style>
